import React, { useState, useRef, useEffect } from 'react';
import { Chart, registerables } from 'chart.js';
import { ChartDataset } from '../model/ChartDataset';
import { getTooltip } from '../../model/Chart';
Chart.register(...registerables);

const BubbleChart = ({ datasets, labels }: Props) => {
  const containerRef = useRef();
  const chartRef = useRef();
  const [chart, setChart] = useState<any>(null);

  useEffect(() => {
    if(chart) {
      chart.destroy();
    }
    const width = chartRef.current.offsetWidth;
    const height = chartRef.current.offsetHeight;
    const data = {
      name: 'root',
      children: []
    };
    let total = 0;
    for(let dataset of datasets) {
      data.children.push({
        name: 'test',
        size: dataset.data[0].r
      });
      total += dataset.data[0].r;
    }
    var nodes = d3.layout.pack()
      .value(d => {
        return d.size;
      })
      .size([width, height])
      .padding(4)
      .nodes(data);
    nodes.shift();
    for(let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      datasets[i].data = [{
        x: node.x,
        y: node.y,
        label: (datasets[i].data[0].r / total * 100).toFixed(1) + '%',
        r: node.r,
      }];
    }
    setChart(new Chart(chartRef.current, {
      type: 'bubble',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        color: '#646467',
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: getTooltip()
        },
        scales: {
          x: {
            display: false,
            grid: {
              display: false
            },
            ticks: {
              display: false
            },
            border: {
              display: false
            }
          },
          y: {
            display: false,
            grid: {
              display: false
            },
            ticks: {
              display: false,
            }
          }
        }
      }
    }));
  }, [ datasets, labels ]);

  return (
    <div ref={containerRef} className="d-flex h-100 align-items-center">
      <canvas ref={chartRef}></canvas>
    </div>
  );
}

interface Props {
  datasets: ChartDataset[],
  labels: string[]
}

export { BubbleChart };